import BigNumber from 'bignumber.js';
import { getNumSysFormatConf } from './i18n';
import { getLang } from '../common/utils';
export class I18nNumber {
    constructor(value, lang) {
        this.value = new BigNumber(value);
        this.lang = getLang(lang);
        this.numSysFormatConf = getNumSysFormatConf(this.lang);
        this.ROUND_UP = BigNumber.ROUND_UP;
        this.ROUND_DOWN = BigNumber.ROUND_DOWN;
        this.ROUND_CEIL = BigNumber.ROUND_CEIL;
        this.ROUND_FLOOR = BigNumber.ROUND_FLOOR;
        this.ROUND_HALF_UP = BigNumber.ROUND_HALF_UP;
        this.ROUND_HALF_DOWN = BigNumber.ROUND_HALF_DOWN;
        this.ROUND_HALF_EVEN = BigNumber.ROUND_HALF_EVEN;
        this.ROUND_HALF_CEIL = BigNumber.ROUND_HALF_CEIL;
        this.ROUND_HALF_FLOOR = BigNumber.ROUND_HALF_FLOOR;
    }
    getValue() {
        return this.value;
    }
    // 获取当前值
    toFixed(decimalPlaces, roundingMode) {
        this.value = new BigNumber(this.value.toFixed(decimalPlaces, roundingMode));
        return this;
    }
    toFormat(decimalPlaces, roundingMode, fmt) {
        return this.value.toFormat(decimalPlaces, roundingMode, {
            ...this.numSysFormatConf,
            ...(fmt || {}),
        });
    }
    toNumber() {
        return this.value.toNumber();
    }
    toPrecision(significantDigits, roundingMode) {
        this.value = new BigNumber(this.value.toPrecision(significantDigits, roundingMode));
        return this;
    }
    comparedTo(n, base) {
        return this.value.comparedTo(n, base);
    }
    abs() {
        this.value = this.value.abs();
        return this;
    }
    plus(n, base) {
        this.value = this.value.plus(n, base);
        return this;
    }
    minus(n, base) {
        this.value = this.value.minus(n, base);
        return this;
    }
    times(n, base) {
        this.value = this.value.times(n, base);
        return this;
    }
    div(n, base) {
        this.value = this.value.div(n, base);
        return this;
    }
    mod(n, base) {
        this.value = this.value.mod(n, base);
        return this;
    }
    isValid() {
        return this.value.isNaN() === false && this.value.isFinite() === true;
    }
    static isValid(value) {
        const bigNumber = new BigNumber(value);
        return bigNumber.isNaN() === false && bigNumber.isFinite() === true;
    }
}
